export default __webpack_public_path__ + "static/media/icon-arrow-button-left.e842f2b2.svg";